module.exports = __webpack_public_path__ + "img/img_39@2x.eb44330f.png";